import React, { Component } from "react"

import ReactApexChart from "react-apexcharts"

class LineGraphWest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            series: [
                {
                    name: "MAX",
                    data: [5, 5, 5, 5, 5, 5, 5,],
                },
                {
                    name: "TSO",
                    data: [-6, -4, 2.1, 1, -3, 2.2, 4,],
                },
                {
                    name: "PTT",
                    data: [5, 4, -2.5, 3.5, -2, 4.2, 7.66,],
                },
                {
                    name: "EGAT",
                    data: [0, 0, 0, 0, 0, 0, 0,],
                },
                {
                    name: "MIN",
                    data: [-5, -5, -5, -5, -5, -5, -5,],
                },
            ],
            options: {
                chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
                colors: ["#FE5555", "#FF7F37", "#62C6FF", "#FFF577", "#FE5555",],
                dataLabels: { enabled: !1 },
                stroke: { width: [3, 3, 3, 3, 3], curve: "straight", dashArray: [8, 0, 0, 0, 8] },
                title: { text: "Percent (%)", align: "left" },
                markers: { size: 0, hover: { sizeOffset: 6 } },
                xaxis: {
                    // text: "Date",
                    categories: [
                        "Date 0",
                        "Date 5",
                        "Date 10",
                        "Date 15",
                        "Date 20",
                        "Date 25",
                        "Date 30",
                        "Date 31"
                        // "01 Jan",
                        // "02 Jan",
                        // "03 Jan",
                        // "04 Jan",
                        // "05 Jan",
                        // "06 Jan",
                        // "07 Jan",
                        // "08 Jan",
                        // "09 Jan",
                        // "10 Jan",
                        // "11 Jan",
                        // "12 Jan",
                    ],
                },
                tooltip: {
                    y: [
                        {
                            title: {
                                formatter: function (e) {
                                    return e + " (mins)"
                                },
                            },
                        },
                        {
                            title: {
                                formatter: function (e) {
                                    return e + " per session"
                                },
                            },
                        },
                        {
                            title: {
                                formatter: function (e) {
                                    return e
                                },
                            },
                        },
                    ],
                },
                grid: { borderColor: "#f1f1f1" },
            },
        }
    }
    render() {
        return (
            <React.Fragment>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="line"
                    height="400"
                    className="apex-charts"
                />
            </React.Fragment>
        )
    }
}

export default LineGraphWest
